import React from 'react';
import TableIcon from '@mui/icons-material/GridOn';
import LeaderboardIcon from '@mui/icons-material/Leaderboard';

export enum DateVentilation {
    YEARLY = 'yearly',
    MONTHLY = 'monthly',
}
export enum VentilationType {
    TIME = 'time',
    NATURE = 'nature',
}
export enum NatureVentilationType {
    NATURE = 'nature',
    SERVICE_AND_NATURE = 'service_and_nature',
}
export enum VizType {
    TABLE = 'table',
    GRAPH = 'graph',
}
export type VizT = {
    name: VizType;
    icon: React.ReactNode;
};

const vizInfo: Record<VizType, VizT> = {
    table: {
        name: VizType.TABLE,
        icon: <TableIcon sx={{ paddingRight: '5px' }} />,
    },
    graph: {
        name: VizType.GRAPH,
        icon: <LeaderboardIcon sx={{ paddingRight: '5px' }} />,
    },
};
export default vizInfo;
